module.exports = __webpack_public_path__ + "static/media/Whats.842b9273.svg";